<template>
    <div class="bloc-search-sms d-flex align-items-center">
        <button type="button" class="btn search-sms-toggle" :aria-label="$t('search')" @click="showInputSearch()">
            <font-awesome-icon :icon="['fas', 'search']"/>
        </button>
        <label v-if="searchShow" for="searchSmsInput" class="sr-only">{{ $t('search-conv') }}</label>
        <transition name="search-fade">
            <input
                v-if="searchShow"
                id="searchSmsInput"
                ref="searchSmsInput"
                v-model="search"
                type="search"
                class="form-control search-sms-input"
                :placeholder="$t('search-conv')"
                @keyup="changeTxtSearch()"
                @search="clearTxtSearch()"
            >
        </transition>
        <div v-if="searchShow && search !== ''" class="search-sms-results d-flex align-items-center">
            <span v-if="searchCountResult > 0">
                <template v-if="arrowBtnActivated">{{ $t('Result') }} {{ elemHighlighted }} {{ $t('of') }} {{ searchCountResult }}</template>
                <template v-else>{{ searchCountResult }} {{ searchCountResult > 1 ? $t('results') : $t('result') }}</template>
            </span>
            <span v-else class="font-nunito-italic">{{ $t('no-results-found') }}</span>
            <template v-if="searchCountResult > 0">
                <button type="button" class="btn search-sms-arrow" :disabled="elemHighlighted === 0" @click="previousResultClick()">
                    <font-awesome-icon :icon="['fas', 'chevron-up']"/>
                </button>
                <button type="button" class="btn search-sms-arrow" :disabled="elemHighlighted === searchCountResult" @click="nextResultClick()">
                    <font-awesome-icon :icon="['fas', 'chevron-down']"/>
                </button>
            </template>
        </div>
    </div>
</template>

<script>
export default {
    emits: ['searchChange', 'searchClear', 'nextResultClick', 'previousResultClick'],

    props: {
        searchCountResult: {
            default: 0,
            type:    Number
        },
        elemHighlighted: {
            default: null,
            type:    Number
        },
        resetSearch: {
            default: false,
            type:    Boolean
        },
        arrowBtnActivated: {
            default: false,
            type:    Boolean
        }
    },

    watch: {
        resetSearch () {
            this.showInputSearch();
        }
    },

    data () {
        return {
            search:     '',
            searchShow: false
        };
    },

    methods: {
        /**
         * Text Search changed
         */
        changeTxtSearch () {
            this.$emit('searchChange', this.search);
        },

        /**
         * Show the previous result
         */
        previousResultClick () {
            this.$emit('previousResultClick');
        },

        /**
         * Show the next result
         */
        nextResultClick () {
            this.$emit('nextResultClick');
        },

        /**
         * Clear the Search input
         */
        clearTxtSearch () {
            this.$emit('searchClear');
        },

        /**
         * Show the input of search
         */
        showInputSearch () {
            this.searchShow = !this.searchShow;
            if (!this.searchShow) {
                this.search = '';
                this.$emit('searchClear');
            } else {
                this.$nextTick(() => {
                    this.$refs.searchSmsInput?.focus();
                    this.$emit('searchClear');
                });
            }
        }
    }
};
</script>
